// Sent on every CF request so medpal-cf's session-timeout middleware applies
// the admin-web inactivity window. Single source of truth for both call sites
// (FirebaseFunctionsService.buildHeaders + SessionTimeoutService) so the
// header name/value can't drift between them.
export const CLIENT_PLATFORM_HEADER = 'X-Client-Platform';
export const CLIENT_PLATFORM = 'admin-web';
